<!-- This file is auto-generated don't edit it! -->
<h1 id="preview">Preview</h1>
<p><ui-select-docs-preview></ui-select-docs-preview></p>
<h1 id="description">Description</h1>
<p>Default button.</p>
<h1 id="usage">Usage</h1>
<pre><code class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ui-select</span>
    [(<span class="hljs-attr">selected</span>)]=<span class="hljs-string">"value"</span>
    (<span class="hljs-attr">selectedChange</span>)=<span class="hljs-string">"valueChanged($event)"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">ui-option</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"Hello"</span>&gt;</span>Hello<span class="hljs-tag">&lt;/<span class="hljs-name">ui-option</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">ui-option</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"World"</span>&gt;</span>World<span class="hljs-tag">&lt;/<span class="hljs-name">ui-option</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">ui-option</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"Bannerflow"</span>&gt;</span>Bannerflow<span class="hljs-tag">&lt;/<span class="hljs-name">ui-option</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">ui-select</span>&gt;</span></code></pre>
<h1 id="inputs">Inputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
<tbody><tr>
<td align="left">showSelectAll</td>
<td align="left">&#64;summary:<br/> Show &#39;Select All&#39; in the options. <br/><br/>&#64;description:<br/> By default &#39;Select All&#39; is not shown but in some cases there is a need to show it.</td>
</tr>
</tbody></table>
<h1 id="outputs">Outputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
</table>
